const HYPERLINK_FORMULA_PATTERN =
  /^\s*=\s*HYPERLINK\s*\(\s*"((?:[^"]|"")*)"\s*(?:[,;]\s*.+?\s*)?\)\s*$/i;

const isSafeHyperlinkDestination = (destination: string): boolean => {
  try {
    const url = new URL(destination);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export const getSafeHyperlinkUrl = (
  rawInput: string | null | undefined,
): string | null => {
  if (!rawInput) return null;

  const match = rawInput.match(HYPERLINK_FORMULA_PATTERN);
  if (!match) return null;

  const destination = match[1].replace(/""/g, '"');
  return isSafeHyperlinkDestination(destination) ? destination : null;
};

type OpenWindow = (
  url?: string | URL,
  target?: string,
  features?: string,
) => Window | null;

export const openHyperlinkInNewTab = (
  url: string,
  openWindow: OpenWindow = (...args) => window.open(...args),
) => {
  if (!isSafeHyperlinkDestination(url)) return;

  const openedWindow = openWindow(url, "_blank", "noopener,noreferrer");

  if (openedWindow) openedWindow.opener = null;
};
